import styled, { css } from 'styled-components';
import FormWithProvider from 'components/forms/form/Form';
import Button from 'components/button/Button';
import theme from 'styles/theme';
import { AgencyDnsSettingStatus } from 'models/CustomDomains';

export const InfoPanel = styled.div`
  background-color: #eef2fb;
  border: 1px solid #d5e0f5;
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 12px 15px;

  p {
    margin-bottom: 2px;
  }
`;

export const InfoPanelTitle = styled.p`
  color: ${theme.colors.primary};
  font-weight: bold;
`;

export const FinishConnectingText = styled.p`
  margin-bottom: 15px;
`;

export const SectionForm = styled(FormWithProvider)`
  margin: 0 0 25px 25px;
`;

export const SectionHeader = styled.div`
  align-items: center;
  display: flex;
  font-weight: bold;
  gap: 10px;
  margin-bottom: 12px;
`;

const statusTagStyles = {
  [AgencyDnsSettingStatus.PENDING]: css`
    background-color: #fcf8e3;
    border-color: #c9ba9b;
    color: #8a6d3b;
  `,
  [AgencyDnsSettingStatus.CONNECTED]: css`
    background-color: #dff0d8;
    border-color: #a3c293;
    color: #3c763d;
  `,
  [AgencyDnsSettingStatus.ERROR]: css`
    background-color: #f2dede;
    border-color: #c9a1a1;
    color: #a94442;
  `,
};

export const StatusTag = styled.span<{
  $status:
    | AgencyDnsSettingStatus.PENDING
    | AgencyDnsSettingStatus.CONNECTED
    | AgencyDnsSettingStatus.ERROR;
}>`
  border: 1px solid;
  border-radius: 3px;
  font-weight: normal;
  padding: 3px 12px;

  ${({ $status }) => statusTagStyles[$status]}
`;

export const FieldRow = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
`;

export const FieldLabel = styled.label`
  align-items: center;
  display: flex;
  flex: 0 0 110px;
  font-weight: normal;
  gap: 5px;
  margin-bottom: 0;
  padding-top: 7px;
`;

export const FieldControl = styled.div`
  flex: 1;

  .form-group {
    margin-bottom: 0;
  }

  /* GenericFormField wraps the control in a grid Col — flatten its padding
     so the input spans the full row, aligned with the CNAME Value control */
  [class*='col-'] {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const SectionActions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 4px;
`;

export const CancelButton = styled(Button)`
  border-color: #a94442;
  color: #a94442;
`;

export const StatusNote = styled.p<{ $isError?: boolean }>`
  color: ${({ $isError }) => ($isError ? '#a94442' : theme.colors.gray600)};
  margin: 0 0 12px;
`;

export const PropagationNote = styled.p`
  color: ${theme.colors.gray600};
  font-size: 12px;
  margin-top: 8px;
`;
